import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
// services
import { loginAdmin } from '../../../api/service';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');

  const login = async () => {
    console.log('here');
    if (email !== '' && password !== '') {
      const admin = {
        email,
        password,
        type: 'admin',
      };
      // setEmail('');
      // setPassword('');
      await loginAdmin(admin)
        .then((req, res) => {
          const { status, message } = req.data;
          if (status === 'failed') {
            alert(message);
          } else {
            localStorage.setItem('token', req.data.token);
            navigate('/dashboard', { replace: true });
          }
        })
        .catch((err) => alert(err));
    }
  };

  return (
    <>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField
          type="email"
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="Government Email ID "
        />

        <TextField
          name="password"
          label="Password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={login}>
        Login
      </LoadingButton>
    </>
  );
}
